module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/KnightFight.54e11a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/KnightFight.jpg
// module id = KabW
// module chunks = 0